import React,{useState} from 'react';
import LlenaPromovidos from './RPLlenaPromovidos';
import XLSX from 'xlsx';
import moment from 'moment';
import ReactTooltip from "react-tooltip";
const RPTablaPromot = ({datosJS,seccionId}) => {
    let datos=datosJS;    
    const [tabla2,setTabla]=  useState("");      
    const [promovido,guardarPromovido] = useState({ nombre:''});
    const [registro,setRegistro]=useState("")
    const [nombrePromot,setNombrePromot]=useState("")
    let auxArreglo=[];
    const [arreExcel,setArreExcel]=useState(["#","INE","Promovido","Dirección","Nacimiento"])
    const RenglonNum =(valorId,regis,PromNomb)=>{
        //console.log(regis);
        setTabla(valorId);
        setNombrePromot(PromNomb);
        setRegistro(regis);
    }
    const exportFile = () => {
        /* convert state to workbook */
        let today = new Date();                    
        let fec = moment(today);
        //console.log(fec.format("YYMMDDHHMMSS"));
        const ws = XLSX.utils.aoa_to_sheet(auxArreglo);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, fec.format("YYMMDDHHmmss")+" Promotores de la sección "+seccionId +".xlsx")
    };
    function filtro(){        
        let auxCadena=nombre.trim();   
        auxArreglo=[]                  
        let info=datos.filter((dat)=>dat.promotorNom.toUpperCase().search(auxCadena.toUpperCase() ) != -1)         
        return TablaPromo(info);
    }

    function TablaPromo(auxdatos) {
        let numRenglon=0;
        let auxi2=["#","Promotores","Promovidos"];
        auxArreglo.push(auxi2);
        let tot= Object.keys(auxdatos).length;
        if(tot===0){
            let auxi3=["","Sin","Promotores"]
            auxArreglo.push(auxi3);            
        }           
        return(
            <div id="tamTablaPromotoresReportes">
                <table className="table is-sobrepuesto " style={{overflowY: +'auto' }} >
                    <thead >    
                        <tr>            
                            <th style={{padding: 0.2 +'rem'}}>Total</th>  
                            <th style={{padding: 0.2 +'rem'}}>Promotores</th>            
                        </tr>                        
                    </thead>  
                    <tbody>          
                        {auxdatos.map((promotor,index) => {
                            let auxNombre="";
                            auxNombre= promotor.promotorNom;    
                            //console.log(auxNombre);
                            let auxi=[index+1,auxNombre,promotor.promotorPromovidos]
                            auxArreglo.push(auxi);
                            numRenglon++;                          
                        return (                  
                            <tr className={ tabla2 === promotor.promotorId ? 'is-seleccionado' : '' }  key={numRenglon} onClick={ () => RenglonNum(promotor.promotorId,promotor,auxNombre) }  >                                
                                <th className="tablaTR " style={{padding: 0.2 +'rem'}}><span className="alinear is-size-7">{promotor.promotorPromovidos}  </span></th>
                                <th className="tablaTR " style={{padding: 0.2 +'rem'}}><span className="alinear is-size-7">{auxNombre}  </span></th>                                                    
                            </tr>              
                            );
                        })
                        }                                
                    </tbody>
                </table>
            </div>
        );
        }
    

	//extraer el promo
	const {nombre} = promovido;        
    const onChange = e =>
    {   let expNopermitida = new RegExp('[0-9._:$!%-({})?/*|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&!expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {
        guardarPromovido({
            ...promovido, //copiamos el nombre
            [e.target.name] : e.target.value  
        })
    }
        /*guardarPromovido({
            ...promovido, //copiamos el nombre
            [e.target.name] : e.target.value  
        })*/
    };

    const datGeneral =registro? ( <LlenaPromovidos promid={tabla2} nombrePromot={nombrePromot}/> ):(null)
    const contenido = promovido? (filtro()):(TablaPromo(datos));
    const llamada= datosJS?(contenido):(<div><h2>No contiene datos</h2></div>)
    const btnExportar = <span data-tip="Exportar Promotores"><a className="pt-2 pl-2"  onClick={exportFile}>
        <img  className="pt-2 " src="export.svg"  alt="" border="0" height="30" width="30"/> 
    </a></span>
    return (

        <div className="contenido-tbPromov py-1">
            <div className="tile is-ancestor ">
                <div className="tile is-4 is-horizontal is-parent">
                    <div className="tile is-child box">                        
                        <div className="container">
                            <div className="field is-horizontal">            
                                <div className="field-body">
                                    <input
                                        className="input" 
                                        type="promo"
                                        name="nombre"                         
                                        placeholder="Buscar promotor"
                                        value={nombre}
                                        onChange={onChange}/>
                                </div>
                                {/* <button disabled={!arreExcel.length>1} className="button pl-2" onClick={exportFile}>Exportar</button> */}
                                {btnExportar}
                                <ReactTooltip place="left" type="success" effect="solid" />
                            </div>		            
                            {llamada}
                        </div>
                    </div>
                </div>
            </div>
            <div  className="card-tabla">
            {datGeneral}
            </div>
        </div>
        
      );
}
  
export default RPTablaPromot;